import { divIcon } from 'leaflet';
import { renderToString } from 'react-dom/server';
import type React from 'react';


const IconMarker = (
  direction: number,
  img: string,
  onClick: () => void,
  selected = false,
  pulseColor = "#0d6efd"
) => {  
 
  const iconStyle = {
    width: '32px',
    height: '32px',
    transform: `rotate(${direction}deg)`,
    position: 'absolute' as const,
    top: '50%',
    left: '50%',
    marginLeft: '-16px',
    marginTop: '-16px',
    zIndex: 2,
  };
 

  const htmlString = renderToString(
    <div className={`vehicle-marker-icon${selected ? " is-selected" : ""}`} style={{ "--vehicle-pulse-color": pulseColor } as React.CSSProperties}>
      <span className="vehicle-marker-pulse" />
      <div style={iconStyle}>{<img src={img} onClick={onClick} alt="" />}</div>
    </div>
  ); 
 
  return divIcon({
    className: 'custom-icon',
    iconSize: selected ? [56, 56] : [32, 32], 
    iconAnchor: selected ? [28, 28] : [16, 16],
    popupAnchor: [0, -30],
    html: htmlString ,
  });
};

export default IconMarker;


